<template>
  <v-row justify="center" style="padding-top: 10px;" v-if="editedItem">
      <v-card color="#CCCCCC">
        <v-card-title class="text-h5">
          Animador
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col
              cols="12"
              sm="12"
            >
              <v-row>
                <v-col
                  cols="12"
                  sm="12"
                >
                  <v-text-field
                    v-model="editedItem.Name"
                    label="Nombre"
                    outlined
                    hide-details
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                  style="padding: 10px 20px;"
                >
                  <translate
                    v-model="editedItem.Description"
                    label="Descripci�n"
                    :languages="languages"
                    type="text"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                >
                  
                  <small>Imagen:</small>
                  <div style="padding:20px 10px 0 10px;">
                    <select-image 
                      :key="editedItem.lmu"
                      :image="editedItem.Image"
                      :defaultImage="editedItem.Image"
                      :onChange="handleChangeImage"
                      :locale="locale"
                      :folder="'ab-01-common'"
                      :imageWidth="600"
                      :imageHeight="700"
                      :aspectRatio="9/12"
                    />
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <delete-item
            v-if="editedItem.ID"
            :id="editedItem.ID"
            :onDeleteItem="handleDelete"
            
          />
          <v-btn
            @click="() => onClose(null)"
          >
            {{ $t('common.cancel', locale) }}
          </v-btn>
          <v-btn
            color="primary"
            @click="handleSave"
          >
            {{ $t('common.save', locale) }}
          </v-btn>
        </v-card-actions>
      </v-card>
  </v-row>
</template>
<script>
import api from '@/services/api'
//import utils from '@/services/utils'
import SelectImage from '@/components/selectImage/Index'
import Translate from '@/components/Translate'
import DeleteItem from '@/components/DeleteItem' 
export default {
  components: {
    SelectImage,
    Translate,
    DeleteItem,
  },
  props: {
    contentTypeID: {
      type: String,
      required: true,
    },
    value: {
      type: Object,
      required: true,
    },
    locale: {
      type: String,
      requried: true,
    },
    onClose: {
      type: Function,
      required: true,
    },
    languages: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    editedItem: null,
  }),
  watch : {
    value () {
      this.prepareValue()
    },
    'value.ID' () {
      this.prepareValue()
    },
  },
  mounted () {
    this.prepareValue()
  },
  methods: {
    prepareValue () {
      const aux = this.value ? JSON.parse(JSON.stringify(this.value)) : null
      if (aux) aux.lmu = new Date().toISOString()
      this.editedItem = aux
    },
    handleChangeImage (v) {
      if (!v) return 
      this.editedItem.Image = v.base64
      this.editedItem.newImage = v
      this.editedItem.lmu = new Date().toISOString()
    },
    handleSave () {
      if (this.editedItem.ID) {
        api.updateItem ('dviewcontent', `v1/private/activity-barcelo-01/${this.contentTypeID}/entertainers/`, this.editedItem.ID, this.editedItem)
          .then(() => {   
            this.onClose(true)
          })
      } else {
        api.addItem ('dviewcontent', `v1/private/activity-barcelo-01/${this.contentTypeID}/entertainers`, this.editedItem)
          .then(() => {   
            this.onClose(true)
          })
      }
    },
    handleDelete () {
      if (!this.editedItem.ID) return
      api.deleteItem ('dviewcontent', `v1/private/activity-barcelo-01/${this.contentTypeID}/entertainers/`, this.editedItem.ID)
        .then(() => {   
          this.onClose(true)
        })
    },
  },
}
</script>
